<template>
<PageView title="专项整治通知修改">
  <template slot="action">
    <a-button type="primary" @click="add">保存</a-button>
  </template>
  <ExpertYearAssessForm ref="evectionForm"/>
</PageView>
</template>

<script>
import { PageView } from '@/layouts'
import ExpertYearAssessForm from '@/epp/expertmain/expertyearassess/common/ExpertYearAssessForm'
export default {
  name: 'ExpertYearAssessEdit',
  components: { PageView,
    ExpertYearAssessForm },
  methods: {
    add () {
      this.$refs.evectionForm.submit()
    }
  }
}
</script>

<style scoped>

</style>
